import { Apiv2GetRequest } from '../../api-v2';

export const state = {
  data: {
    title: 'Dashboard',
    profile: null,
    loadingProfile: false,
    pengumuman: null,
    loadingPengumuman: false,
    chart: null,
    loadingChart: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  profile(state) {
    return state.data.profile;
  },
  chart(state) {
    return state.data.chart;
  },
};

export const mutations = {
  changeDashboard(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getUserProfile({ commit }) {
    commit('changeDashboard', {
      loadingProfile: true,
    });

    let result = await Apiv2GetRequest(`dashboard/profile`);
    commit('changeDashboard', {
      loadingProfile: false,
      profile: result.error ? null : result.data.object,
    });

    return result.error ? false : true;
  },
  async getUserInfo({ commit }) {
    commit('changeDashboard', {
      loadingPengumuman: true,
    });

    let result = await Apiv2GetRequest(`dashboard/pengumuman`);
    commit('changeDashboard', {
      loadingPengumuman: false,
      pengumuman: result.error ? null : result.data.object,
    });

    return result.error ? false : true;
  },
  async getUserChart({ commit }) {
    commit('changeDashboard', {
      loadingChart: true,
    });

    let result = await Apiv2GetRequest(`dashboard/chart`);
    commit('changeDashboard', {
      loadingChart: false,
      chart: result.error ? null : result.data.object,
    });

    return result.error ? false : true;
  },
};
